'use strict';

var NetworkError = require('./NetworkError.js');

class TooManyRequestsError extends NetworkError.NetworkError {
    retryAfter;
    constructor(message = 'Too Many Requests', retryAfter) {
        super(message, 429);
        this.retryAfter = retryAfter;
    }
    toJSON() {
        const json = super.toJSON();
        return {
            ...json,
            ...(this.retryAfter ? { retryAfter: this.retryAfter } : {}),
        };
    }
}

exports.TooManyRequestsError = TooManyRequestsError;
//# sourceMappingURL=TooManyRequestsError.js.map
